/**
 * external libs
 */
import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
    SortableContext,
    arrayMove,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Table } from 'antd';
import React, {useMemo, useState} from 'react';
import DndKeyTableEnum from '../../../../enums/DNDKeyTable';
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Age',
        dataIndex: 'age',
    },
    {
        title: 'Address',
        dataIndex: 'address',
    },
];
const Row = ({draggableKey , ...props }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: props['data-row-key'],
    });
    const style = {
        ...props.style,
        transform: CSS.Transform.toString(
            transform && {
                ...transform,
                scaleY: 1,
            },
        ),
        transition,
        cursor: draggableKey === DndKeyTableEnum.default ? 'move':"auto",
        ...(isDragging
            ? {
                position: 'relative',
                zIndex: 9999,
            }
            : {}),
    };

    if(draggableKey === DndKeyTableEnum.folder){
        if(Array.isArray(props.children)){
            return (
                <tr {...props} ref={setNodeRef} style={style} {...attributes} >
                    {props.children.map( elem => {
                        if(elem.key === "ordinal"){
                            return (
                                <td {...listeners} style={{cursor: "move"}} className={"ant-table-cell"}>
                                    {elem}
                                </td>
                            )
                        }

                        return (
                            <td className={"ant-table-cell"}>
                                {elem}
                            </td>
                        )
                    })}
                </tr>
            );
        }

        return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />
    }

    return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
};

export default function DraggableTable({onDragEndHandler, dataSource, draggableKey, ...props}) {
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 1,
            },
        }),
    );
    const onDragEnd = ({ active, over }) => {
        if (active.id !== over?.id && onDragEndHandler) {
            onDragEndHandler({ active, over }, dataSource)
        }
    };
    return (
        <DndContext sensors={sensors} modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
            <SortableContext
                items={dataSource.map((i) => i._indexDnD)}
                strategy={verticalListSortingStrategy}
            >
                <Table
                    components={{
                        body: {
                            row: (props) => <Row {...props} draggableKey={draggableKey}/>,
                        },
                    }}
                    rowKey="_indexDnD"
                    {...props}
                    dataSource={dataSource}
                />
            </SortableContext>
        </DndContext>
    );
};
